const HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY = 'helpChatWindowStatus';
const MINIMIZED_WINDOW_STATUS = 'minimized';
const OPEN_WINDOW_STATUS = 'open';

function loadZendeskSettings() {
  window.zESettings = {
    webWidget: {
      color: {
        bypassAccessibilityRequirement: true,
      },
      helpCenter: {
        chatButton: {
          '*': I18n.t('zendesk.webWidget.helpCenter.chatButton'),
        },
        title: {
          '*': I18n.t('zendesk.webWidget.helpCenter.title'),
        },
        searchPlaceholder: {
          '*': I18n.t('zendesk.webWidget.helpCenter.searchPlaceholder'),
        },
      },
      launcher: {
        chatLabel: {
          '*': I18n.t('zendesk.webWidget.launcher.chatLabel'),
        },
        label: {
          '*': I18n.t('zendesk.webWidget.launcher.label'),
        },
      },
      contactOptions: {
        contactButton: {
          '*': I18n.t('zendesk.webWidget.contactOptions.contactButton'),
        },
      },
    },
  };
}

function loadZopimTranslations() {
  window.$zopim.livechat.window.setTitle(
    I18n.t('zendesk.zopim.window.title')
  );

  window.$zopim.livechat.prechatForm.setGreetings(
    I18n.t('zendesk.zopim.prechatForm.greetings')
  );
}

function hideZendeskIcon() {
  const frameContents = $('#webWidget').contents();
  frameContents.find('.Icon--zendesk').hide();
}

function getChatWindowStatusFromLocalStorage() {
  try {
    return localStorage.getItem(HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY);
  } catch (e) {
    console.log(e);
  }
  return null;
}

function shouldOpenZopimChatWindow(){
  const windowStatusFromLocalStorage = getChatWindowStatusFromLocalStorage();
  if (windowStatusFromLocalStorage) {
    return windowStatusFromLocalStorage === OPEN_WINDOW_STATUS && currentChatInProgress();
  }
  return currentChatInProgress();
}

function currentChatInProgress() {
  return window.$zopim.livechat.isChatting();
}

function setChatWindowStatus(newStatus) {
  try {
    if (newStatus) {
      localStorage.setItem(HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY, newStatus);
    } else {
      localStorage.removeItem(HELP_CHAT_WINDOW_STATUS_LOCAL_STORAGE_KEY);
    }
  } catch (e) {
    console.log(e)
  }
}

function getDepartment(chatDepartmentId) {
  return window.$zopim.livechat.departments.getDepartment(chatDepartmentId);
}

function setStatus(newStatus) {
  window.$zopim.livechat.setStatus(newStatus);

  const isOnline = (newStatus === 'online');
  Reverb.ZopimActions.onlineStatusUpdated(isOnline);

  // show on mobile if online
  if (window.Reverb.MobileDetection.isMobileBrowser() && isOnline) {
    window.zE.show();
  }
}

/* eslint-disable */
function loadWidget() {
  window.zEmbed || function (e, t) { var n, o, d, i, s, a = [], r = document.createElement("iframe"); window.zEmbed = function () { a.push(arguments) }, window.zE = window.zE || window.zEmbed, r.src = "javascript:false", r.title = "", r.role = "presentation", (r.frameElement || r).style.cssText = "display: none", d = document.getElementsByTagName("script"), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document; try { o = s } catch (e) { n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);', o = s } o.open()._l = function () { var e = this.createElement("script"); n && (this.domain = n), e.id = "js-iframe-async", e.src = "https://assets.zendesk.com/embeddable_framework/main.js", this.t = +new Date, this.zendeskHost = "reverbdotcom.zendesk.com", this.zEQueue = a, this.body.appendChild(e) }, o.write('<body onload="document._l();">'), o.close() }();
}
/* eslint-enable */

function loadZendeskEmbed(zendeskAllowedLocale, chatDepartmentId, tags, searchLabels) {
  loadZendeskSettings();
  loadWidget();

  window.zE(() => {
    try {
      // set widget locale
      window.zE.setLocale(zendeskAllowedLocale);

      // set search suggestions
      window.zE.setHelpCenterSuggestions({
        labels: searchLabels,
      });
      // Attempt to hide the zendesk icon.
      // In the case that the chat widget is offline,
      // the $zopim code below will not load and we don't
      // have a good way of knowing when the dom is available.
      // So, just wait a bit.
      window.setTimeout(() => {
        hideZendeskIcon();
      }, 500);

    } catch (e) {
      // https://sentry.io/reverb-llc/discovery-ui/issues/675754070
      // I suspect some users are getting a cached version of the zendesk widget
      console.error('could not set up zendesk widget');
    }

    window.$zopim(() => {
      let cachedStatus;

      const meta = JSON.parse(atob(document.querySelector('meta[name="current-user"]').content));

      if (meta.user.name) {
        window.$zopim.livechat.setName(meta.user.name);
        window.$zopim.livechat.setEmail(meta.user.email);
      }

      window.$zopim.livechat.departments.filter(''); // removes department selection dropdown
      window.$zopim.livechat.departments.setVisitorDepartment(chatDepartmentId);
      window.$zopim.livechat.addTags(tags);

      loadZopimTranslations();
      hideZendeskIcon();

      // hide mobile until we can confirm the status
      if (window.Reverb.MobileDetection.isMobileBrowser()) {
        window.zE.hide();
      }

      window.$zopim.livechat.setOnConnected(() => {
        // this cannot be run on load or it will not work
        // wait until we are connected, then set the size
        window.$zopim.livechat.window.setSize('small');

        // zopim has an onShow callback, but because we are wrapping the zopim chat window
        // it is not fired when the window is maximized.
        // https://api.zopim.com/files/meshim/widget/controllers/liveChatAPI/Window-js.html#$zopim.livechat.window.onShow
        // To get onShow-eque behavior, we will monkeypatch the normal window.show function here
        var oldShow = window.$zopim.livechat.window.show;
        window.$zopim.livechat.window.show = () => {
          setChatWindowStatus(OPEN_WINDOW_STATUS);
          return oldShow.apply(this);
        };

        // show the chat window if there is a chat in progress
        if (shouldOpenZopimChatWindow()) {
          window.$zopim.livechat.window.show();
        }

        window.$zopim.livechat.window.onHide(() => {
          setChatWindowStatus(MINIMIZED_WINDOW_STATUS);
        });

        window.$zopim.livechat.setOnChatEnd(() => {
          setChatWindowStatus();
        });

        window.$zopim.livechat.setOnStatus(() => {
          const department = getDepartment(chatDepartmentId);

          // this will call setOnStatus again, so we need to prevent
          // an infinite loop
          // status is one of 'online', 'away', or 'offline'
          const newStatus = department.status;
          if (cachedStatus === newStatus) { return; }

          cachedStatus = newStatus;
          setStatus(newStatus);
        });
      });
    });
  });
}

module.exports = {
  loadZendeskEmbed,
};

window.addEventListener('DOMContentLoaded', function() {
  if (window.__loadZendeskEmbed) {  // app/views/shared/external/_zendesk_embed.haml
    window.setTimeout(__loadZendeskEmbed, 1000); // Injected from rails
  }
});



// WEBPACK FOOTER //
// ./javascripts/components/zendesk.js